export default __webpack_public_path__ + "static/media/setting.f9763bb7.svg";